/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_QuestionInputs */

const en_us2_profile_editors_split_question = /** @type {(inputs: Profile_Editors_Split_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to split the week`)
};

const pt_br2_profile_editors_split_question = /** @type {(inputs: Profile_Editors_Split_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como dividir a semana`)
};

const es_419_profile_editors_split_question = /** @type {(inputs: Profile_Editors_Split_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo dividir la semana`)
};

const pt_pt2_profile_editors_split_question = /** @type {(inputs: Profile_Editors_Split_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como dividir a semana`)
};

const fr_fr2_profile_editors_split_question = /** @type {(inputs: Profile_Editors_Split_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment répartir la semaine`)
};

const de_de2_profile_editors_split_question = /** @type {(inputs: Profile_Editors_Split_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie die Woche aufteilen`)
};

const it_it2_profile_editors_split_question = /** @type {(inputs: Profile_Editors_Split_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come dividere la settimana`)
};

/**
* | output |
* | --- |
* | "How to split the week" |
*
* @param {Profile_Editors_Split_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_question = /** @type {((inputs?: Profile_Editors_Split_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_question(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_question(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_question(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_question(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_question(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_question(inputs)
	return en_us2_profile_editors_split_question(inputs)
});
export { profile_editors_split_question as "profile-editors.split_question" }